import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const inputClasses =
  "shadow-sm appearance-none border border-gray-300 rounded-xl w-full py-3 px-4 text-[#1B1B1F] " +
  "leading-tight focus:outline-none focus:ring-2 focus:ring-[#F2B705] focus:border-[#F2B705] transition-colors";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('الرجاء إدخال البريد الإلكتروني وكلمة المرور.');
      setLoading(false);
      return;
    }

    // Simulate an API call for login
    setTimeout(() => {
      if (email === 'user@example.com' && password === 'password123') {
        if (rememberMe) {
          console.log('Remember Me is checked. Saving user data (simulated).');
        }
        setLoading(false);
        navigate('/');
      } else {
        setError('البريد الإلكتروني أو كلمة المرور غير صحيحة.');
        setLoading(false);
      }
    }, 1500);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F6F5F2] p-4" dir="rtl">
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)] w-full max-w-md">
        <div className="text-center mb-6">
          <Link
            to="/"
            className="text-2xl font-extrabold text-[#1B1B1F]"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            MEME STORE
          </Link>
          <h2
            className="text-2xl font-bold text-[#1B1B1F] mt-4"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            تسجيل الدخول
          </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-[#1B1B1F] text-sm font-bold mb-2">
              البريد الإلكتروني
            </label>
            <input
              type="email"
              id="email"
              className={inputClasses}
              placeholder="أدخل بريدك الإلكتروني"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-5">
            <label htmlFor="password" className="block text-[#1B1B1F] text-sm font-bold mb-2">
              كلمة المرور
            </label>
            <input
              type="password"
              id="password"
              className={inputClasses}
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Remember Me checkbox and Forgot Password link */}
          <div className="flex items-center justify-between mb-6">
            <label htmlFor="rememberMe" className="flex items-center text-[#1B1B1F] text-sm gap-2 cursor-pointer">
              <input
                type="checkbox"
                id="rememberMe"
                className="h-4 w-4 accent-[#F2B705] rounded border-gray-300 focus:ring-[#F2B705]"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              حفظ بيانات الدخول
            </label>
            <Link
              to="/forgot-password"
              className="font-bold text-sm text-[#1B1B1F] hover:text-[#F2B705] transition-colors"
            >
              نسيت كلمة المرور؟
            </Link>
          </div>

          {error && (
            <p className="text-[#FF4D4D] text-xs font-medium mb-4 text-center">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="bg-[#F2B705] hover:bg-[#1B1B1F] text-[#1B1B1F] hover:text-white font-bold py-3 px-6
              rounded-full w-full transition-colors duration-300 disabled:opacity-60 disabled:cursor-not-allowed
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2"
          >
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>

          <p className="text-center text-gray-600 text-sm mt-6">
            ليس لديك حساب؟{' '}
            <Link to="/register" className="text-[#1B1B1F] hover:text-[#F2B705] font-bold transition-colors">
              سجل الآن
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
